var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileProject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.0947 7h-4.979c-0.44182 0-0.8 0.35817-0.8 0.8v1.7784c0 0.44186 0.35818 0.80002 0.80001 0.80002h4.9789c0.44182 0 0.8-0.35816 0.8-0.80002v-1.7784c0-0.44182-0.35818-0.8-0.8-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.0947 11.73h-6.2947c-0.44183 0-0.8 0.35816-0.8 0.8v1.7783c0 0.44184 0.35817 0.8 0.8 0.8h6.2947c0.44183 0 0.8-0.35816 0.8-0.8v-1.7783c0-0.44184-0.35817-0.8-0.8-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.0947 16.459h-6.2947c-0.44183 0-0.8 0.35816-0.8 0.8v1.7784c0 0.44184 0.35817 0.8 0.8 0.8h6.2947c0.44183 0 0.8-0.35816 0.8-0.8v-1.7784c0-0.44184-0.35817-0.8-0.8-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.432 10.649h3.6631c0.44184 0 0.8-0.35816 0.8-0.8v-1.1027c0-0.44183-0.35816-0.8-0.8-0.8h-3.6631c-0.44184 0-0.8 0.35817-0.8 0.79999v1.1027c0 0.44184 0.35816 0.8 0.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.432 14.432h5.7684c0.44184 0 0.8-0.35816 0.8-0.8v-1.1026c0-0.44184-0.35816-0.8-0.8-0.8h-5.7684c-0.44184 0-0.8 0.35816-0.8 0.8v1.1026c0 0.44184 0.35816 0.8 0.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.432 18.216h1.0315c0.44184 0 0.8-0.35816 0.8-0.8v-1.1027c0-0.44184-0.35816-0.8-0.8-0.8h-1.0315c-0.44184 0-0.8 0.35816-0.8 0.8v1.1027c0 0.44184 0.35816 0.8 0.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.116 18.216h1.5579c0.44184 0 0.8-0.35816 0.8-0.8v-1.1027c0-0.44184-0.35816-0.8-0.8-0.8h-1.5579c-0.44184 0-0.8 0.35816-0.8 0.8v1.1027c0 0.44184 0.35816 0.8 0.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.779 4.7027h-0.50528c-0.44184 0-0.8 0.35818-0.8 0.8v15.697c0 0.44184 0.35816 0.8 0.8 0.8h0.50528c0.44184 0 0.8-0.35816 0.8-0.8v-15.697c0-0.44182-0.35816-0.8-0.8-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.505 4.1622-2.084-2.1622h4.2106z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileProject);
export default __webpack_public_path__ + "static/media/file-project.934312707b68a041a0cd7292591df36d.svg";
export { ForwardRef as ReactComponent };